import React, { Component } from 'react';
import RkHeader from "../GeneralComponents/RkHeader"
import Table from '../components/configurationRisk/Table'

class ConfigurationShow extends Component {
    render() {
        const isActivity = this.props.module == "actividad";
        return (
            <React.Fragment>
                <RkHeader
                    title={`${this.props.headerTitleName}`}
                    subtitle={"Configuración"}
                    icon="fas fa-toolbox"
                    showNew={false}
                    showFilter={false}
                />

                <nav className="rk-breadcrumb" aria-label="breadcrumb">
                    <a href={isActivity ? "/risk/activities" : "/risk/criterios"} data-turbolinks="true">
                        <i className="fas fa-th"></i> {isActivity ? "Actividad de riesgos" : "Criterios de riesgos"}
                    </a>
                    <span className="rk-breadcrumb__sep">/</span>
                    <span className="rk-breadcrumb__current">{this.props.headerTitleName}</span>
                </nav>

                <Table
                    data={this.props.data} 
                    module={this.props.module}
                />
            </React.Fragment>
        );
    }
}

export default ConfigurationShow;
WebpackerReact.setup({ ConfigurationShow });